import React from "react";
import {
  Badge,
  Box,
  IconButton,
  styled,
} from "@mui/material";
import KeyboardDoubleArrowLeftOutlinedIcon from "@mui/icons-material/KeyboardDoubleArrowLeftOutlined";
import TableChartIcon from "@mui/icons-material/TableChartOutlined";
import { H7TitleLarge } from "../../../components/StyledComponents/Typography/Typography.tsx";
import { StyledIconButton } from "../../../components/StyledComponents/Buttons/AuradineButtons";
import { ManageColumns } from "./ManageColumns/ManageColumns";
import MinerFilters from "./MinerFilters/MinerFilters.js";
import useOrgSiteGroupTreeContext from "../../context/useOrgSiteGroupTreeContext.js"
import { useTheme } from "../../../ThemeContext/ThemeContext.js";

const CustomBadge = styled(Badge)(({ colors }) => ({
    "& .MuiBadge-badge": {
      backgroundColor: colors?.text?.primary,
    color: colors?.primary?.contrastText,
      fontSize: "0.75rem", // Optional: Adjust font size
      padding: "0.25rem", // Optional: Adjust padding
    },
}));

export const MinerTableHeader = React.memo((props) => {
  const {
    setRightSidePanelOpen,
    rightSidePanelOpen,
    gridRef,
    totalCount
  } = props;
  const { orgSelectedName, siteSelectedName, groupSelectedName } = useOrgSiteGroupTreeContext();
  const { colors } = useTheme();
  return (
    <Box
      className={"table-container-header"}
      display={"flex"}
      flexDirection={"row"}
      justifyContent={"space-between"}
      alignItems={"center"}
    >
      <CustomBadge
        colors={colors}
        badgeContent={totalCount}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        sx={{}}
        max={1000000}
      >
        <Box pr={3}>
          <H7TitleLarge> All miners</H7TitleLarge>
        </Box>
      </CustomBadge>
      <Box
        display={"flex"}
        flexDirection={"row"}
        gap={2}
        alignItems={"center"}
      >
        <MinerFilters />
        <ManageColumns />
      </Box>
    </Box>
  );
});
